import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgClose = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 9.58581L16.6569 3.92896L18.0711 5.34317L12.4142 11L18.0711 16.6569L16.6569 18.0711L11 12.4142L5.34317 18.0711L3.92896 16.6569L9.58581 11L3.92896 5.34317L5.34317 3.92896L11 9.58581Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgClose);

export default ForwardRef;
